<template>
<div v-show="isModalVisible">
<div class="modal-mask">
      <div class="modal-container" @click.stop>
      <!-- Modal Header -->
      <div class="modal-header">
          <div class="col-11 p-0 float-left text-center">
              <img class="w-60 mt1" src="@/assets/MM-logo.png" alt="MentorMentee" width="100px">
          </div>
      </div>
      <!-- Modal body -->
      <div class="modal-body">

        <div class="form-group row mb-0">
            <div  class="heading col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" style="padding-left: 15px;">
              Terms of Use
            </div>
            <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 cols" style="padding-left: 15px; padding-top: 15px;">
            <div class="custom-control custom-checkbox">
                <input
                type="checkbox"
                id="news_subscription"
                name="news_subscription"
                ref="news_subscription"
                v-model="license_accepted" 
                @click="changeUserLicense($event)"
                :checked="license_checked" class="custom-control-input" 
                :value="1" style="margin-top: 4px; height: 12px;"
                >
                <label class="custom-control-label" for="news_subscription" style="font-size: 14px;">I accept and agree to the <a class="click_tag" href="https://mentormentee.com/eula" target="_blank">User License Agreement</a></label>
            </div>  
            </div>
            <div class="col-12 p-0" style="margin-top: 30px;">
            <div class="col-6 p-0 float-left" style="text-align: left;">
                &nbsp;
            </div>
            <div class="col-6 p-0 float-left" style="text-align: right;" v-if="disable_license_button == true">
                <button type="submit" class="bold btn btn-md ma-grey" style="font-weight: bold !important; border-radius: 5px !important;">Continue</button>
            </div>
            <div class="col-6 p-0 float-left" style="text-align: right;" v-else>
                <button type="submit" class="bold btn btn-md ma-blue-btn" style="font-weight: bold !important; border-radius: 5px !important;" @click="onSubmit()">Continue</button>
            </div>
            </div>


        </div>



      </div>
      </div>
</div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import axios from 'axios';
import router from '../../router/index.js';

export default {
  props: ['isModalVisible'],
  data() {
    return {
      loading: false,
        apiUrl: '',
        logo: '',
        license_accepted: false,
        license_checked: false,
        disable_license_button: true,

    }
  },
  methods: {
    closeModal() {
      this.$emit('close');
    },
    changeUserLicense(event) {
      if(event.target.checked == true) {
        this.disable_license_button = false;
      }
      else {
        this.disable_license_button = true;
      }
    },
    onSubmit() {
      this.disable_license_button = true;
        axios('/desktop/create-end-user-license',
        {
          method: 'POST',
          data: {
            account_id: this.$store.state.user_accountid,
          },
        })
        .then(() => {
          this.disable_license_button = false;
          this.$emit('close');
        })
        .catch((error) => {
          this.disable_license_button = false;
        });

    },
  },
    created() {
      this.apiUrl = process.env.API_ENDPOINT;
      this.logo = this.$logoName;
    },

}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: fixed;
  left: 50%;
  top: 50%;
  -ms-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 450px;
  height: auto;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 15px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;
 }
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.modal-title {
  font-size: 14px;
  font-weight: 900;
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 5px;
}
.ma-blue-btn {
  border-radius: 10px;
  padding-left: 30px;
  padding-right: 30px;
}
.closeBtn {
  width: 110px;
}
.form-control { font-size: 14px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
.reassign_options {
  margin-top: 1px;
}
.heading {
    font-size: 18px;
    font-weight: bold;

}
.ma-grey, .ma-grey:hover, .ma-grey:focus {
    background-color: #707070;
    color: #FFF;
  padding-left: 30px;
  padding-right: 30px;
  padding-top: 5px;
  padding-bottom: 5px;
  

}
.click_tag, .click_tag:hover, .click_tag:active {
    color: #00ACEE;
    text-decoration: underline !important;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/end_user_license_agreement_modal.vue